<template>
	<div
		class="search-btn"
		@click="$emit('click', $event)"
	>
		<Icon
			icon-name="search"
			:size="size"
		/>
	</div>
</template>

<script>
export default {
	name:  'SearchButton',
	props: {
		size: {
			type:    String,
			default: 'lg',
		},
	},

};
</script>

<style lang="scss" scoped>
.search-btn {
	cursor: pointer;
}

</style>
